import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (!authService.$userSignal()) {
    await firstValueFrom(authService.initUserByStorage());
  }
  try {
    const canActivate = !!authService.$userSignal();
    if (!canActivate) {
      console.warn('User is not logged in, redirecting to login');
      // Store the attempted URL for redirecting after login
      sessionStorage.setItem('redirectUrl', state.url);

      // Check if route has preferredLogin set to 'partner' - redirect directly to partner login
      const preferredLogin = route.data?.['preferredLogin'];
      if (preferredLogin === 'partner') {
        // Redirect directly to partner login portal
        const partnerLoginUrl = environment.apiUrlPartner;
        const separator = partnerLoginUrl.includes('?') ? '&' : '?';
        const redirectUrl = `${partnerLoginUrl}${separator}redirectUrl=${encodeURIComponent(window.location.origin + '/auth/partner')}`;
        window.location.href = redirectUrl;
        return false;
      }

      router.navigate(['/login']);
    }
    return canActivate;
  } catch {
    return false;
  }
};
